import React, { useState, useEffect } from 'react'

import Paper from '@mui/material/Paper'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import { useNavigate } from 'react-router-dom'

const Menu = () => {
  let tournamentView
  const [valueBottomNavigation, setValueBottomNavigation] = useState(0)
  const navigate = useNavigate()

  const handleNavigationChange = (event, newValue) => {
    setValueBottomNavigation(newValue)
    switch (newValue) {
      case 0:
        navigate('/tournaments-list')
        break
      case 1:
        navigate('/create-tournament')
        break
      case 2:
        navigate('/team-requests')
        break
      default:
        break
    }
  }
  const getPathValue = (path) => {
    switch (path) {
      case '/tournaments-list':
        return 0
      case '/create-tournament':
        return 1
      case '/team-requests':
        return 2
      default:
        return 0
    }
  }

  useEffect(() => {
    setValueBottomNavigation(getPathValue(window.location.pathname))
  }, [])

  return (
    <>
      {tournamentView}
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          paddingBottom: 2,
        }}
        elevation={3}
      >
        <BottomNavigation
          showLabels
          value={valueBottomNavigation}
          onChange={handleNavigationChange}
        >
          <BottomNavigationAction label="Турниры" icon={<EmojiEventsIcon />} />
          <BottomNavigationAction
            label="Создать турнир "
            icon={<AddCircleIcon />}
          />
          {/* <BottomNavigationAction
            label="Заявки от команд"
            icon={<AccountCircleIcon />}
          /> */}
        </BottomNavigation>
      </Paper>
    </>
  )
}

export default Menu
